import { useCallback, useState } from "react";
import { ModuleHeader } from "../../../shared/components/ModuleHeader";
import { DocumentListView } from "../pages/document-list/components/DocumentListView";
import { UploadView } from "../pages/upload/components/UploadView";
import { DocumentDetailView } from "../pages/document-detail/components/DocumentDetailView";
import styles from "./DocuParserPanel.module.css";

type View = { readonly kind: "list" } | { readonly kind: "upload" } | { readonly kind: "detail"; readonly id: number };

interface DocuParserPanelProps {
  readonly onBack?: () => void;
}

export function DocuParserPanel({ onBack }: Readonly<DocuParserPanelProps>) {
  const [view, setView] = useState<View>({ kind: "list" });

  const goToList = useCallback(() => setView({ kind: "list" }), []);
  const goToUpload = useCallback(() => setView({ kind: "upload" }), []);
  const openDocument = useCallback((id: number) => setView({ kind: "detail", id }), []);

  return (
    <div className={styles.panel}>
      <ModuleHeader title="DocuParser" subtitle="PDF → Word conversion with OCR" onBack={onBack} />
      <div className={styles.body}>
        {view.kind === "list" && <DocumentListView onUpload={goToUpload} onOpenDocument={openDocument} />}
        {view.kind === "upload" && <UploadView onDone={goToList} />}
        {view.kind === "detail" && <DocumentDetailView documentId={view.id} onBack={goToList} />}
      </div>
    </div>
  );
}
